
export const POINT = 'point';
export const LINE = 'linestring';
export const POLYGON = 'polygon';

export const POINT_NAME = 'Точка';
export const LINE_NAME = 'Линия';
export const POLYGON_NAME = 'Полигон';

export const LAYER_TYPE_LIST = [
  {
    id: POINT,
    name: POINT_NAME,
  },
  {
    id: LINE,
    name: LINE_NAME,
  },
  {
    id: POLYGON,
    name: POLYGON_NAME,
  },
];

export const WFS = 'wfs';
export const URL = 'url';

export const WFS_NAME = 'WFS';
export const URL_NAME = 'URL';

export const HTTP_SOURCE_LIST = [
  {
    id: WFS,
    name: WFS_NAME,
  },
  {
    id: URL,
    name: URL_NAME,
  },
];

export const EPSG3857 = 'EPSG:3857';
export const EPSG4326 = 'EPSG:4326';

export const SRS_LIST = [
  {
    srs: EPSG4326,
    text: EPSG4326,
  },
  {
    srs: EPSG3857,
    text: EPSG3857,
  },
];
